import { render, staticRenderFns } from "./UpdateContract.vue?vue&type=template&id=4454ae74&scoped=true"
import script from "./UpdateContract.vue?vue&type=script&lang=js"
export * from "./UpdateContract.vue?vue&type=script&lang=js"
import style0 from "./UpdateContract.vue?vue&type=style&index=0&id=4454ae74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4454ae74",
  null
  
)

export default component.exports